<script setup>
import { defineLazyHydrationComponent } from '#imports'

const LazyFooterMobileColumns = defineLazyHydrationComponent(
  'visible',
  () => import('~/components/layout/footer/MobileColumns.vue')
)
const LazyFooterDesktopColumns = defineLazyHydrationComponent(
  'visible',
  () => import('~/components/layout/footer/DesktopColumns.vue')
)
const LazyFooterBottom = defineLazyHydrationComponent(
  'visible',
  () => import('~/components/layout/footer/Bottom.vue')
)

// Props
const props = defineProps({
  footer: {
    type: Object,
    default: () => ({})
  },
  additionalLanguages: {
    type: Array,
    default: () => []
  },
  siteHandle: {
    type: String,
    default: ''
  },
  hideFooterNav: {
    type: Boolean,
    default: false
  },
  globalCtaSettings: {
    type: Object,
    default: () => ({})
  }
})

// Computed properties
const columns = computed(() => {
  if (!Array.isArray(props.footer) || props.footer.length === 0) return []
  return props.footer.slice(0, -1)
})

const helperInfo = computed(() => {
  if (!Array.isArray(props.footer) || props.footer.length === 0) return null
  return props.footer[props.footer.length - 1]
})

const footerInfo = computed(() => {
  const info = helperInfo.value || {}
  return {
    title: info.title || '',
    button: info.button || {}
  }
})

const footerBottomInfo = computed(() => {
  const info = helperInfo.value || {}
  return {
    image: info.image || {},
    links: info.children || [],
    copyright: info.copyright || '',
    businessInfo: info.businessInfo || []
  }
})

</script>

<!-- -------------------------------------------------------------------------------------------------
    Template
------------------------------------------------------------------------------------------------- -->

<template>
<footer class="layout-footer"
  :class="{ '--hide-nav': hideFooterNav }">

  <LazyFooterMobileColumns
    v-if="!hideFooterNav"
    :hydrate-on-visible="{ rootMargin: '300px' }"
    :footerColumns="columns"
    :footerInfo="footerInfo"
    :siteHandle="siteHandle"
    :globalCtaSettings="globalCtaSettings"
    data-hydration="lazy-hydration"
  />

  <LazyFooterDesktopColumns
    v-if="!hideFooterNav"
    :hydrate-on-visible="{ rootMargin: '300px' }"
    :footerColumns="columns"
    :footerInfo="footerInfo"
    :siteHandle="siteHandle"
    :globalCtaSettings="globalCtaSettings"
    data-hydration="lazy-hydration"
  />

  <hr>

  <LazyFooterBottom
    :hydrate-on-visible="{ rootMargin: '300px' }"
    :footerBottomInfo="footerBottomInfo"
    :additionalLanguages="additionalLanguages"
    :siteHandle="siteHandle"
    data-hydration="lazy-hydration"
  />

</footer>
</template>

<!-- -------------------------------------------------------------------------------------------------
    Styling
------------------------------------------------------------------------------------------------- -->

<style scoped>

footer {
  padding-top: 64px;
  padding-bottom: 52px;
  color: var(--color-gray-900);
  overflow: hidden;
  border-top: 1px solid var(--color-gray-150);
  background: #fff;

  content-visibility: auto;
  contain-intrinsic-size: 1310px;

  @media (min-width: 1200px) {
    padding-top: 80px;
    padding-bottom: 70px;

    contain-intrinsic-size: 572px;

    &.--hide-nav {
      padding-top: 16px;
    }
  }
}

hr {
 display: none;
}

@media (min-width: 1200px) {
  footer:not(.--hide-nav) hr {
    display: block;
  }
}

</style>